export var CONTEXT_NAMESPACE = '__react_css_component_cache';
export var ID_NAMESPACE = '__react_css_component_id-';


//////////////////
// WEBPACK FOOTER
// ../component-library/node_modules/react-css-component/es/utils/namespace.js
// module id = 234
// module chunks = 0